
import StoryblokComponent from '~/components/Storyblok/Component'
import breakpointMixin from '~/mixins/breakpoints'

export default {
  components: { StoryblokComponent },
  mixins: [breakpointMixin],
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  computed: {
    containerStyles() {
      const styles = {}

      styles.maxWidth = this.getBreakpointValue(this.blok?.maxWidth)
      styles.margin = this.getBreakpointValue(this.blok?.margin)
      styles.padding = this.getBreakpointValue(this.blok?.padding)
      styles.top = this.getBreakpointValue(this.blok?.top)
      styles.right = this.getBreakpointValue(this.blok?.right)
      styles.bottom = this.getBreakpointValue(this.blok?.bottom)
      styles.left = this.getBreakpointValue(this.blok?.left)

      return styles
    },
    outerStyles() {
      const styles = {}

      styles.paddingBottom = `calc(100% / calc(${this.getBreakpointValue(
        this.blok?.aspectRatio
      )}))`

      return styles
    },
  },
}
